import { Component } from '@angular/core';
import { AlertController, IonicPage } from 'ionic-angular';
import { TextServiceProvider } from '../../core/services/text-service/text-service';
import { MotivizerHistory, RankingBonusThresholdPointTransfer } from '../interfaces/motivizer-history.interface';
import { KpiServiceProvider } from "../../ranking/services/kpi-service/kpi-service";
import { KpiConfig, KpiDto } from "../../ranking/services/kpi-service/kpi.interface";
import { ENVIRONMENT } from "../../../../environments/environment";
import { ConfigServiceProvider } from "../../core/services/config-service/config-service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { DisplayServiceProvider } from "../../core/services/display-service/display-service";
import { KpiDefinition } from "../../ranking/interfaces/kpi-definition";
import { MapOfNumberTo, Utils } from "../../ranking/interfaces/utils";

@IonicPage()
@Component({
  selector: 'page-motivizer',
  templateUrl: 'motivizer.html',
})
export class MotivizerPage {
  private readonly transferPointsUrl: string = '../../../../assets/achievements.json';
  public readonly dateFormat = 'dd.MM.yyyy';
  private readonly httpOptions = {
    headers: new HttpHeaders().set('Content-type', 'application/json; charset=utf-8'),
  };
  public pointsTotal: number = 0;
  public history: MotivizerHistory[] = [];
  public pointsToTransfer: number;
  public kpiDefinitionIdToTransfer: number;
  public kpiDefinitions: KpiDefinition[] = []
  public kpiDefinitionsById: MapOfNumberTo<KpiDefinition> = {}

  constructor(
      public textService: TextServiceProvider,
      public kpiServiceProvider: KpiServiceProvider,
      public configService: ConfigServiceProvider,
      public http: HttpClient,
      public displayService: DisplayServiceProvider,
      public alertCtrl: AlertController
  ) {
  }

  ionViewWillEnter() {
    this.setKpis();
  }

  private setKpis() {
    Promise.all([
      this.kpiServiceProvider.getKpisOfCurrentUser(),
      this.kpiServiceProvider.getKpiDefinitions()
    ]).then(([summaryKpisUser, kpiDefinitions]) => {
      const kpiIds = summaryKpisUser.map(kpiDto => kpiDto.kpiId)
      if(kpiIds.length > 0) {
        this.kpiDefinitionIdToTransfer = kpiIds[0]
      }
      this.kpiDefinitions = kpiDefinitions.filter(kpiDefinition => kpiIds.indexOf(kpiDefinition.id) != -1)
      this.kpiDefinitionsById = Utils.toMapByNumeric(this.kpiDefinitions, 'id');
      this.history = summaryKpisUser.map(kpiDto => ({points: kpiDto.value, kpiId: kpiDto.kpiId, date: kpiDto.date}))
      this.sumKpisOfSelectedType();
    });
  }

  sendToMotivizer() {
    if (this.pointsToTransfer <= 0) {
      this.alertCtrl.create({
        title: this.textService.get('defaultErrorTitle'),
        message: this.textService.get('invalidTransferPoints'),
      }).present()
      return;
    }

    if (!this.kpiDefinitionIdToTransfer) {
      this.alertCtrl.create({
        title: this.textService.get('defaultErrorTitle'),
        message: this.textService.get('invalidTransferPointsType'),
      }).present()
      return;
    }

    let kpiConfig = this.displayService.getScreenComponent('dummy', 'motivizer') as KpiConfig;
    const dto: RankingBonusThresholdPointTransfer = {
      kpiDefinitionId: this.kpiDefinitionIdToTransfer,
      value: Math.floor(this.pointsToTransfer)
    };

    this.http.post(this.getSource(), dto, this.httpOptions)
        .toPromise()
        .then(() => this.setKpis())
        .catch((error) => {
          console.error(error.error.description)
          this.alertCtrl.create({
            title: this.textService.get('defaultErrorTitle'),
            message: error.error.description,
          })
              .present()
        });
  }

  private getSource(): string {
    if (ENVIRONMENT.useLocalAchievements) return this.transferPointsUrl;
    return this.configService.getUrl('transferPoints');
  }

  shouldDisplaySendButton(): boolean {
    return !this.pointsToTransfer;
  }


  sumKpisOfSelectedType() {
    this.pointsTotal = Math.floor(this.history.filter(h => h.kpiId == this.kpiDefinitionIdToTransfer).reduce((pointsTotal, kpiDto) => pointsTotal + kpiDto.points, 0))
  }
}



// WEBPACK FOOTER //
// ./src/modules/motivizer/pages/motivizer.ts